import { createReducer } from '../utils/DataReducer';

export const inscripcionReducer = createReducer({
  dataName: 'INSCRIPCION',
});

export const cacheReducer = createReducer({
  dataName: 'CACHE',
});
